export enum OrderStatus {
  Confirmed = "CONFIRMED",
  Delivered = "DELIVERED",
  Completed = "COMPLETED",
}
